import React from "react";

export const ProfileIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="currentColor"
      className="bi bi-person-circle"
      viewBox="0 0 16 16"
    >
      <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
      <path
        fillRule="evenodd"
        d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
      />
    </svg>
  );
};

export const SettingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="currentColor"
      className="bi bi-gear"
      viewBox="0 0 16 16"
    >
      <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z" />
      <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z" />
    </svg>
  );
};

export const LogoutIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="currentColor"
      className="bi bi-box-arrow-left"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        d="M6 12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 1 6.5 2h8A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 12.5v-2a.5.5 0 0 1 1 0v2z"
      />
      <path
        fillRule="evenodd"
        d="M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H10.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3z"
      />
    </svg>
  );
};

export const LeftSideIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="19"
      fill="none"
      viewBox="0 0 12 19"
    >
      <path
        fill="#fff"
        d="M4.594 17.774l6.632-6.75a2.573 2.573 0 00-.032-3.641L4.445.75C2.804-.863.026.324.045 2.623L.16 16.004c.02 2.3 2.82 3.411 4.433 1.77z"
      ></path>
    </svg>
  );
};

export const GroupsAddIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="105"
      height="105"
      fill="none"
      viewBox="0 0 105 105"
    >
      <path
        fill="#4885C4"
        d="M52.5 0A53.145 53.145 0 000 52.5 53.145 53.145 0 0052.5 105 53.144 53.144 0 00105 52.5 53.144 53.144 0 0052.5 0zm30 56.25H56.25V82.5h-7.5V56.25H22.5v-7.5h26.25V22.5h7.5v26.25H82.5v7.5z"
      ></path>
    </svg>
  );
};

export const GroupInfoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="86"
      height="80"
      fill="none"
      viewBox="0 0 86 80"
    >
      <path
        fill="#4885C4"
        d="M26.561 40c-4.837.149-8.794 2.054-11.87 5.714H8.69c-2.449 0-4.51-.602-6.182-1.808C.836 42.701 0 40.938 0 38.616 0 28.11 1.851 22.857 5.554 22.857c.18 0 .829.313 1.949.938s2.575 1.257 4.367 1.897c1.792.64 3.568.96 5.33.96 2 0 3.986-.343 5.957-1.027a22.184 22.184 0 00-.224 2.946c0 4.137 1.21 7.947 3.628 11.429zm47.972 28.438c0 3.57-1.09 6.39-3.27 8.46C69.083 78.965 66.188 80 62.574 80H23.426c-3.613 0-6.51-1.034-8.69-3.103-2.18-2.068-3.27-4.888-3.27-8.46 0-1.577.053-3.117.157-4.62.105-1.503.314-3.125.628-4.866a37.74 37.74 0 011.187-4.844 22.914 22.914 0 011.925-4.352c.807-1.414 1.733-2.62 2.778-3.617 1.045-.997 2.321-1.793 3.83-2.388 1.507-.595 3.172-.893 4.994-.893.298 0 .94.32 1.926.96.985.64 2.075 1.354 3.27 2.143 1.194.788 2.791 1.503 4.792 2.143 2 .64 4.016.96 6.047.96 2.03 0 4.046-.32 6.047-.96 2-.64 3.598-1.355 4.793-2.143a509.064 509.064 0 013.27-2.143c.985-.64 1.627-.96 1.925-.96 1.822 0 3.487.298 4.995.893s2.784 1.391 3.83 2.388c1.044.997 1.97 2.203 2.776 3.617a22.914 22.914 0 011.927 4.352 37.74 37.74 0 011.186 4.844c.314 1.741.523 3.363.628 4.866.104 1.503.156 3.043.156 4.62zm-45.866-57.01c0 3.155-1.12 5.849-3.36 8.08-2.24 2.233-4.942 3.35-8.107 3.35-3.165 0-5.868-1.117-8.107-3.35-2.24-2.231-3.36-4.925-3.36-8.08 0-3.154 1.12-5.848 3.36-8.08C11.333 1.116 14.035 0 17.2 0c3.165 0 5.868 1.116 8.107 3.348 2.24 2.232 3.36 4.926 3.36 8.08zM60.2 28.572c0 4.733-1.68 8.773-5.04 12.121-3.358 3.348-7.412 5.022-12.16 5.022s-8.802-1.674-12.16-5.022c-3.36-3.348-5.04-7.388-5.04-12.12 0-4.733 1.68-8.773 5.04-12.121 3.358-3.348 7.412-5.022 12.16-5.022s8.802 1.674 12.16 5.022c3.36 3.348 5.04 7.388 5.04 12.12zM86 38.616c0 2.322-.836 4.085-2.508 5.29-1.673 1.206-3.733 1.808-6.182 1.808h-6.002c-3.075-3.66-7.032-5.565-11.87-5.714 2.42-3.482 3.629-7.292 3.629-11.429 0-.863-.075-1.845-.224-2.946a18.049 18.049 0 005.957 1.027c1.762 0 3.538-.32 5.33-.96 1.792-.64 3.248-1.272 4.367-1.897 1.12-.625 1.77-.938 1.949-.938 3.703 0 5.554 5.253 5.554 15.76zM80.267 11.43c0 3.154-1.12 5.848-3.36 8.08-2.24 2.232-4.942 3.348-8.107 3.348-3.165 0-5.868-1.116-8.107-3.348-2.24-2.232-3.36-4.926-3.36-8.08 0-3.155 1.12-5.849 3.36-8.08C62.933 1.115 65.635 0 68.8 0c3.165 0 5.868 1.116 8.107 3.348 2.24 2.232 3.36 4.926 3.36 8.08z"
      ></path>
    </svg>
  );
};

export const PrivacyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="72"
      height="88"
      fill="none"
      viewBox="0 0 72 88"
    >
      <path
        fill="#4885C4"
        d="M36 .916L.75 16.583v23.5c0 21.737 15.04 42.065 35.25 47 20.21-4.935 35.25-25.263 35.25-47v-23.5L36 .916zm-3.917 23.5h7.834v7.833h-7.834v-7.833zm0 15.667h7.834v23.5h-7.834v-23.5z"
      ></path>
    </svg>
  );
};

export const FriendsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="86"
      height="80"
      fill="none"
      viewBox="0 0 86 80"
    >
      <path
        fill="#4885C4"
        d="M26.561 40c-4.837.149-8.794 2.054-11.87 5.714H8.69c-2.449 0-4.51-.602-6.182-1.808C.836 42.701 0 40.938 0 38.616 0 28.11 1.851 22.857 5.554 22.857c.18 0 .829.313 1.949.938s2.575 1.257 4.367 1.897c1.792.64 3.568.96 5.33.96 2 0 3.986-.343 5.957-1.027a22.184 22.184 0 00-.224 2.946c0 4.137 1.21 7.947 3.628 11.429zm47.972 28.438c0 3.57-1.09 6.39-3.27 8.46C69.083 78.965 66.188 80 62.574 80H23.426c-3.613 0-6.51-1.034-8.69-3.103-2.18-2.068-3.27-4.888-3.27-8.46 0-1.577.053-3.117.157-4.62.105-1.503.314-3.125.628-4.866a37.74 37.74 0 011.187-4.844 22.914 22.914 0 011.925-4.352c.807-1.414 1.733-2.62 2.778-3.617 1.045-.997 2.321-1.793 3.83-2.388 1.507-.595 3.172-.893 4.994-.893.298 0 .94.32 1.926.96.985.64 2.075 1.354 3.27 2.143 1.194.788 2.791 1.503 4.792 2.143 2 .64 4.016.96 6.047.96 2.03 0 4.046-.32 6.047-.96 2-.64 3.598-1.355 4.793-2.143a509.064 509.064 0 013.27-2.143c.985-.64 1.627-.96 1.925-.96 1.822 0 3.487.298 4.995.893s2.784 1.391 3.83 2.388c1.044.997 1.97 2.203 2.776 3.617a22.914 22.914 0 011.927 4.352 37.74 37.74 0 011.186 4.844c.314 1.741.523 3.363.628 4.866.104 1.503.156 3.043.156 4.62zm-45.866-57.01c0 3.155-1.12 5.849-3.36 8.08-2.24 2.233-4.942 3.35-8.107 3.35-3.165 0-5.868-1.117-8.107-3.35-2.24-2.231-3.36-4.925-3.36-8.08 0-3.154 1.12-5.848 3.36-8.08C11.333 1.116 14.035 0 17.2 0c3.165 0 5.868 1.116 8.107 3.348 2.24 2.232 3.36 4.926 3.36 8.08zM60.2 28.572c0 4.733-1.68 8.773-5.04 12.121-3.358 3.348-7.412 5.022-12.16 5.022s-8.802-1.674-12.16-5.022c-3.36-3.348-5.04-7.388-5.04-12.12 0-4.733 1.68-8.773 5.04-12.121 3.358-3.348 7.412-5.022 12.16-5.022s8.802 1.674 12.16 5.022c3.36 3.348 5.04 7.388 5.04 12.12zM86 38.616c0 2.322-.836 4.085-2.508 5.29-1.673 1.206-3.733 1.808-6.182 1.808h-6.002c-3.075-3.66-7.032-5.565-11.87-5.714 2.42-3.482 3.629-7.292 3.629-11.429 0-.863-.075-1.845-.224-2.946a18.049 18.049 0 005.957 1.027c1.762 0 3.538-.32 5.33-.96 1.792-.64 3.248-1.272 4.367-1.897 1.12-.625 1.77-.938 1.949-.938 3.703 0 5.554 5.253 5.554 15.76zM80.267 11.43c0 3.154-1.12 5.848-3.36 8.08-2.24 2.232-4.942 3.348-8.107 3.348-3.165 0-5.868-1.116-8.107-3.348-2.24-2.232-3.36-4.926-3.36-8.08 0-3.155 1.12-5.849 3.36-8.08C62.933 1.115 65.635 0 68.8 0c3.165 0 5.868 1.116 8.107 3.348 2.24 2.232 3.36 4.926 3.36 8.08z"
      ></path>
    </svg>
  );
};

export const GroupIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="27"
      fill="none"
      viewBox="0 0 27 27"
    >
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M16.083 16.083l9.042 9.042M10.917 1.875H1.875v9.042h9.042V1.875zm0 14.208H1.875v9.042h9.042v-9.042zM25.125 1.875h-9.042v9.042h9.042V1.875zm-9.042 14.208h9.042-9.042zm0 0v9.042-9.042z"
      ></path>
    </svg>
  );
}

export const EditIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18"
    >
      <path
        stroke="#4885C4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.8"
        d="M12.355 4.056l1.589 1.588m-.567-2.987L9.082 6.952a1.589 1.589 0 00-.435.812L8.25 9.75l1.986-.398c.307-.061.59-.212.811-.434l4.296-4.295a1.39 1.39 0 10-1.966-1.966v0z"
      ></path>
      <path
        stroke="#4885C4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.8"
        d="M14.25 11.25v2.25a1.5 1.5 0 01-1.5 1.5H4.5A1.5 1.5 0 013 13.5V5.25a1.5 1.5 0 011.5-1.5h2.25"
      ></path>
    </svg>
  );
}

export const DeleteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#4885C4"
        d="M6.5 2.938v.187h3v-.188a1.5 1.5 0 00-3 0zm-.938.187v-.188a2.437 2.437 0 014.875 0v.188h4.22a.469.469 0 110 .938h-1.095l-.75 8.945a2.719 2.719 0 01-2.709 2.492H5.897a2.719 2.719 0 01-2.709-2.492l-.75-8.945H1.344a.469.469 0 010-.938h4.218zm-1.44 9.805a1.781 1.781 0 001.775 1.633h4.206a1.78 1.78 0 001.775-1.633l.743-8.867H3.38l.743 8.867zm2.94-6.336a.469.469 0 10-.937 0v5.437a.468.468 0 10.938 0V6.594zm2.344-.469c.259 0 .469.21.469.469v5.437a.469.469 0 11-.938 0V6.594c0-.259.21-.469.47-.469z"
      ></path>
    </svg>
  );
}

export const LockIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="16"
      fill="none"
      viewBox="0 0 12 16"
    >
      <path
        fill="#4885C4"
        d="M5.997 0c1.44 0 2.666 1.01 2.944 2.402a.5.5 0 11-.98.196A1.995 1.995 0 005.996 1C4.941 1 4.076 1.817 4 2.853l-.006.15V5H10a2 2 0 012 2v7a2 2 0 01-2 2H2a2 2 0 01-2-2V7a2 2 0 012-2h.995V3.002A3.002 3.002 0 015.997 0zM10 6H2a1 1 0 00-1 1v7a1 1 0 001 1h8a1 1 0 001-1V7a1 1 0 00-1-1zM6 9.5a1 1 0 110 2 1 1 0 010-2z"
      ></path>
    </svg>
  );
}

